module.exports = __webpack_public_path__ + "img/Coupe_Front.09966b81.svg";